import { apiPost, apiPostInit, getCookie, sleep } from "dlibs";
import { toast } from "@/webmanage/ts/utils/tools";
import { EApi, EErrCode } from "@/webmanage/ts/utils/data_enum";
import { EApi as EApiCommon } from "@/common/ts/data/data_enum";
import { toLoginPage } from "./public";
import { appConfig } from "./appConfig";



export const apiErrCb = async (res: any) => {
    switch (res.ret_code) {
        case EErrCode.needLogin: {
            console.error('需要登录');
            toast.error(res.info);
            await sleep(1.5);
            toLoginPage();
            break;
        }
        case EErrCode.authFail: {
            console.log('无权限');
            toast.error(res.info);
            break;
        }
    }
}

// 执行API初始化
apiPostInit({
    apiUrl: appConfig.apiUrl,
    showMsg: false,
    errCb: (res: any) => {
        apiErrCb(res);
    },
    disposeDataFun: (data: any) => {
        if (typeof data === 'object' && data !== null) {
            // 2. 判断是否已经存在 token 属性
            if (!('token' in data)) {
                data.token = getCookie('token');
            }
        }
        return data;
    },
});
export const $api = (
    api: EApi | EApiCommon | any,
    data?: Record<string, any>,
    errCb?: (data: any) => any,
    showMsg?: boolean,
) => {
    return apiPost(
        api as any,
        data,
        errCb,
        showMsg,
    );
};
